export default function Skeleton() {
  return <div className='absolute left-0 top-0 h-7 w-full pl-2' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='h-full w-full animate-pulse rounded bg-gray-100'></div>
        </div>;
}